// One date formatter for the esercizio's panels, iot and documents. An
// `Instant` printed as it comes is a UTC timestamp with nanoseconds: it tells the
// wrong hour, in a format that belongs to nobody. Every reader below works at
// the reader's own timezone.

const dueCifre = (numero) => String(numero).padStart(2, '0');

const aData = (istante) => {
  if (!istante) return null;
  const data = new Date(istante);
  return Number.isNaN(data.getTime()) ? null : data;
};

/** `dd/mm/yyyy`, or `null` when the instant is missing or unparseable. */
export const formattaData = (istante) => {
  const data = aData(istante);
  if (!data) return null;

  return (
    `${dueCifre(data.getDate())}/${dueCifre(data.getMonth() + 1)}/` +
    `${data.getFullYear()}`
  );
};

/** `dd/mm/yyyy hh:mm`, or `null` when the instant is missing or unparseable. */
export const formattaDataOra = (istante) => {
  const data = aData(istante);
  if (!data) return null;

  return (
    `${formattaData(istante)} ${dueCifre(data.getHours())}:` +
    `${dueCifre(data.getMinutes())}`
  );
};

/**
 * The calendar day the instant falls on, as the `YYYY-MM-DD` a date input
 * holds, or `null` when the instant is missing or unparseable. Never through
 * `toISOString()`, which gives the UTC day: local midnight in Rome is 22:00Z or
 * 23:00Z of the day before.
 */
export const formattaGiornoIso = (istante) => {
  const data = aData(istante);
  if (!data) return null;

  return (
    `${data.getFullYear()}-${dueCifre(data.getMonth() + 1)}-` +
    `${dueCifre(data.getDate())}`
  );
};
